import { brandLogos } from '@liveauctioneers/hammer-ui-core/brandAssets';
import { Loading } from '@liveauctioneers/hammer-ui-core/loading';

const LoadingScreen = () => {
    return (
        <div className="fixed inset-0 z-[2000] flex h-screen items-center justify-center overflow-y-auto overflow-x-hidden">
            <div className="flex flex-col items-center justify-center gap-[26px]">
                <img
                    alt="LiveAuctioneers"
                    className="h-[30px] w-[181px]"
                    data-testid="la-logo-asset"
                    src={brandLogos.LiveAuctioneers.brand}
                />
                <Loading />
            </div>
        </div>
    );
};

export default LoadingScreen;
